import React, { useState } from "react";
import TrustDetailsPopup from "./TrustDetailsPopup";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";

const TrustActionButton = ({
  id,
  setEdit,
  setTrustId,
  toggleShowAddEditTrust,
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleShowModal}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        <span>/</span>
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={() => {
                setEdit(true);
                toggleShowAddEditTrust();
                setTrustId(id);
              }}
            />
          </span>
        </CustomTooltip>
      </span>

      {showView && (
        <TrustDetailsPopup
          showView={showView}
          trustId={id}
          toggleShowModal={toggleShowModal}
          setShowView={setShowView}
        />
      )}
    </>
  );
};

export default TrustActionButton;
